import React, { useState, useEffect } from "react";
import moment from "moment";
import "./TrialCounter.scss";

const TrialCounter = (props) => {
  const [state, setState] = useState({
    duration: moment(),
  });

  useEffect(() => {
    const today = new Date();
    const expirationDate = props.creationDate;
    expirationDate.setDate(expirationDate.getDate() + 30);

    const diff = expirationDate.getTime() - today.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hoursLeft = diff - days * 1000 * 60 * 60 * 24;
    const hours = Math.floor(hoursLeft / (1000 * 60 * 60));

    setState({
      days: days,
      hours: hours,
    });

    setInterval(() => {
      const expirationDate = props.creationDate;

      const diff = expirationDate.getTime() - today.getTime();
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hoursLeft = diff - days * 1000 * 60 * 60 * 24;
      const hours = Math.floor(hoursLeft / (1000 * 60 * 60));

      setState({
        days: days,
        hours: hours,
      });
    }, 30000);
  }, []);

  return (
    <div className={"trial-counter"}>
      <div className={"trial-counter-box days"}>
        <span>{state.days}</span>
        <label className={"theme-color"}>Days</label>
      </div>
      <div className={"trial-counter-box hours"}>
        <span>{state.hours}</span>
        <label className={"theme-color"}>Hours</label>
      </div>
    </div>
  );
};

export default TrialCounter;
